import api from "../api"
export default {
	/**
	 * Gets a list of notifications
	 * @param {number} offset
	 * @param {number} limit
	 */
	async getCSRForm() {
		let value = await api.get(`/csrforms/2022`)
		if (!value || !value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data[0]
		return data
	},
	async getCSRReForm() {
		let value = await api.get(`/csrreforms/2022`)
		if (!value || !value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data[0]
		return data
	},
	/**
	 *
	 * @param {number} requestID
	 * @param {Object[]} answers
	 */
	async submitForm(csrID, answers, answernumbers) {
		let value = await api.post(`/csrassessments`, {
			answers: answers,
			csrID: csrID,
			answernumbers: answernumbers
		})
		//TODO FIX - return submission ID?

		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	async resubmitForm(id,csrID, answers,answernumbers) {
		let value = await api.put(`/csrassessments`, {
			csrid:id,
			answers: answers,
			csrID: csrID,
			answernumbers: answernumbers
		})
		//TODO FIX - return submission ID?

		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	/**
	 *
	 * @param {number} requestID
	 * @param {Object[]} answers
	 */
	async saveSubmission(csrID, answers,answernumbers) {
		let value = await api.put(`/csrdrafts/${csrID}`, {
			answers: answers,
			csrID: csrID,
			answernumbers: answernumbers
		})
		//TODO FIX - return submission ID?

		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	async getCSRAssessments() {
		let value = await api.get(`csrassessments/`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}

		let data = value.data.data
		return data
	},
	async getCSRAssessmentsall() {
		let value = await api.get(`csrassessmentsall/`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}

		let data = value.data.data
		return data
	},
	async getCSRresubmit(clID,state,id) {
		console.log(state)
		let value = await api.put(`csrresubmit/` , {
			clID:clID,
			state: state,
			id: id
		})
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	async notifyCSR(clID) {
		let value = await api.post(`csrresubmit/` , {
			clID:clID,
		})
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	async getCSRAssessment(id) {
		let value = await api.get(`csrassessments/${id}`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}

		let data = value.data.data
		return data
	},
	async getCSRAssessmentByYear(year) {
		let value = await api.get(`/csrassessmentss/${year}`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}

		let data = value.data.data
		return data
	},
	async sendInvitation(recipientIDs) {
		let value = await api.post(`csr-invite`, {recipients: recipientIDs})
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	async saveValueChain(product, businessModel, suppliers, customers, rawMaterials, endUser, positiveFactorsImpact, negativeFactorsImpact, positiveFactorsImpacting, negativeFactorsImpacting, risks, opportunities, stakeholders) {
		let value = await api.post(`csrvaluechain`, {
			product: product,
			businessModel: businessModel,
			suppliers: suppliers,
			customers: customers,
			rawMaterials: rawMaterials,
			endUser: endUser,
			positiveFactorsImpact: positiveFactorsImpact,
			negativeFactorsImpact: negativeFactorsImpact,
			positiveFactorsImpacting: positiveFactorsImpacting,
			negativeFactorsImpacting: negativeFactorsImpacting,
			risks: risks,
			opportunities: opportunities,
			stakeholders: stakeholders
		})
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	async getExistingValueChain() {
		let value = await api.get(`csrvaluechain/`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}

		let data = value.data.data
		return data
	},
	async getEditHistory() {
		let value = await api.get(`valuechainedithistory/`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}

		let data = value.data.data
		return data
	},
	async downloadValueChainPDF(valueChainID, PDFname) {
		let value = await api.get(`/csrvaluechain/${valueChainID}/pdf`, {
			responseType: "blob",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/pdf",
			},
		})

		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}

		const url = window.URL.createObjectURL(new Blob([value.data]))
		const link = document.createElement("a")
		link.href = url
		link.setAttribute("target", "_blank")
		link.setAttribute("download", `${PDFname}.pdf`)
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
	},
	async postCompanyVision(companyVision) {
		let value = await api.post(`csrcompanyvision`, {companyVision: companyVision})
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	async getCompanyVision() {
		let value = await api.get(`csrcompanyvision/`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}

		let data = value.data.data
		return data
	},

	async downloadVsmePDF() {
		const value = await api.get("/vsmepdf", {
			responseType: "blob",
			headers: { "Content-Type": "application/json", Accept: "application/pdf" },
		})
		const url  = window.URL.createObjectURL(new Blob([value.data]))
		const link = document.createElement("a")
		link.href = url
		link.setAttribute("download", "VSME Report.pdf")
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
	},

	async downloadJSON() {
		const value = await api.get("/vsmejson")
		
		const jsonData = typeof value.data === "string" 
			? JSON.parse(value.data)   // parse once to get the real object
			: value.data

		const url = window.URL.createObjectURL(
			new Blob([JSON.stringify(jsonData, null, 2)], { type: "application/json" })
		)

		const link = document.createElement("a")
		link.href = url
		link.setAttribute("download", "VSME_Report.json")
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
		window.URL.revokeObjectURL(url)
	},
	
	//business activity
	async saveVsmeBusiness(
		primaryActivity,
		primaryActivityOther,
		naceCode,
		countriesOfOperation,
		hasCertifications,
		certificationsList,
		ownsProduction,
		hasOutsourcing,
		outsourcedActivities,
		outsourcedPct,
		activeSuppliers,
		supplierAssessment,
		longTermContracts,
		isDraft
	) {
		let value = await api.post(`/vsmeBusinessActivity`, {
			primaryActivity,
			primaryActivityOther,
			naceCode,
			countriesOfOperation,
			hasCertifications,
			certificationsList,
			ownsProduction,
			hasOutsourcing,
			outsourcedActivities,
			outsourcedPct,
			activeSuppliers,
			supplierAssessment,
			longTermContracts,
			isDraft
		})
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data
	},

	async getVsmeBusiness() {
		let value = await api.get(`/vsmeBusinessActivity`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		const data = value?.data?.data?.[0]
		if (!data) throw new Error("No business activity record found for this account.")
		return data
	},

	async updateVsmeBusiness(
		primaryActivity,
		primaryActivityOther,
		naceCode,
		countriesOfOperation,
		hasCertifications,
		certificationsList,
		ownsProduction,
		hasOutsourcing,
		outsourcedActivities,
		outsourcedPct,
		activeSuppliers,
		supplierAssessment,
		longTermContracts,
		isDraft
	) {
		let value = await api.put(`/vsmeBusinessActivity`, {
			primaryActivity,
			primaryActivityOther,
			naceCode,
			countriesOfOperation,
			hasCertifications,
			certificationsList,
			ownsProduction,
			hasOutsourcing,
			outsourcedActivities,
			outsourcedPct,
			activeSuppliers,
			supplierAssessment,
			longTermContracts,
			isDraft
		})
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			throw error
		}
		return value.data.data
	},

	//water usage 
	async saveVsmeWater(
		totalConsumption,
		monitorsUsage,
		monitoringFrequency,
		waterSources,
		waterSourcesOther,
		treatsWastewater,
		recyclsWater,
		hasEfficiencyInitiatives,
		efficiencyDescription,
		hasDisruptions,
		tracksIntensity,
		isDraft
	) {
		let value = await api.post(`/vsmeWater`, {
			totalConsumption,
			monitorsUsage,
			monitoringFrequency,
			waterSources: JSON.stringify(waterSources),
			waterSourcesOther,
			treatsWastewater,
			recyclsWater,
			hasEfficiencyInitiatives,
			efficiencyDescription,
			hasDisruptions,
			tracksIntensity,
			isDraft
		})
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data
	},

	async getVsmeWater() {
		let value = await api.get(`/vsmeWater`)
		if (value?.data?.error?.length > 0) {
			if (value.data.error[0].code === "NOT_FOUND") return null
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			throw error
		}
		return value.data.data?.[0] ?? null
	},

	async updateVsmeWater(
		totalConsumption,
		monitorsUsage,
		monitoringFrequency,
		waterSources,
		waterSourcesOther,
		treatsWastewater,
		recyclsWater,
		hasEfficiencyInitiatives,
		efficiencyDescription,
		hasDisruptions,
		tracksIntensity,
		isDraft
	) {
		let value = await api.put(`/vsmeWater`, {
			totalConsumption,
			monitorsUsage,
			monitoringFrequency,
			waterSources: JSON.stringify(waterSources),
			waterSourcesOther,
			treatsWastewater,
			recyclsWater,
			hasEfficiencyInitiatives,
			efficiencyDescription,
			hasDisruptions,
			tracksIntensity,
			isDraft
		})
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			throw error
		}
		return value.data.data
	},

	//health & safety
	async saveVsmeHealth(
		hasPolicy,
		hasOfficer,
		regulationCompliance,
		hasTraining,
		trainingFrequency,
		hasRiskAssessments,
		tracksNearMiss,
		workplaceAccidents,
		lostTimeInjuries,
		hasFatalities,
		fatalitiesCount,
		inspectionFrequency,
		hasEmergencyProcedures,
		isDraft
	) {
		let value = await api.post(`/vsmeHealth`, {
			hasPolicy,
			hasOfficer,
			regulationCompliance,
			hasTraining,
			trainingFrequency,
			hasRiskAssessments,
			tracksNearMiss,
			workplaceAccidents,
			lostTimeInjuries,
			hasFatalities,
			fatalitiesCount,
			inspectionFrequency,
			hasEmergencyProcedures,
			isDraft
		})
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data
	},

	async getVsmeHealth() {
		let value = await api.get(`/vsmeHealth`)
		if (value?.data?.error?.length > 0) {
			if (value.data.error[0].code === "NOT_FOUND") return null
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			throw error
		}
		return value.data.data?.[0] ?? null
	},

	async updateVsmeHealth(
		hasPolicy,
		hasOfficer,
		regulationCompliance,
		hasTraining,
		trainingFrequency,
		hasRiskAssessments,
		tracksNearMiss,
		workplaceAccidents,
		lostTimeInjuries,
		hasFatalities,
		fatalitiesCount,
		inspectionFrequency,
		hasEmergencyProcedures,
		isDraft
	) {
		let value = await api.put(`/vsmeHealth`, {
			hasPolicy,
			hasOfficer,
			regulationCompliance,
			hasTraining,
			trainingFrequency,
			hasRiskAssessments,
			tracksNearMiss,
			workplaceAccidents,
			lostTimeInjuries,
			hasFatalities,
			fatalitiesCount,
			inspectionFrequency,
			hasEmergencyProcedures,
			isDraft
		})
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			throw error
		}
		return value.data.data
	},

	//diversity & equality
	async saveVsmeDiversity(
		totalEmployees,genderMale,genderFemale,genderOther,leaderMale,leaderFemale,leaderOther,staffMale,staffFemale,staffOther,under25,age25_34,age35_44,age45_54,age55plus,
		nationalities,additionalDemographics,trackPayGap,payGap,promoMale,promoFemale,promoOther,turnoverMale,turnoverFemale,turnoverOther,underrepresentedLeadership,diPolicy,policyRef,responsibleRole,hasTargets,
		targetsDescription,initiatives,initiativesOther,hasTraining,trainingFrequency,trainingDescription,diversityChange,improvements,trackMetrics,metricsTracked,isDraft
	) {
		let value = await api.post(`/vsmeDiversityInclusion`, {
			totalEmployees: totalEmployees, genderMale: genderMale, genderFemale: genderFemale, genderOther: genderOther, leaderMale: leaderMale, leaderFemale: leaderFemale, leaderOther: leaderOther,
			staffMale: staffMale, staffFemale: staffFemale, staffOther: staffOther, under25: under25, age25_34: age25_34, age35_44: age35_44, age45_54: age45_54, age55plus: age55plus, nationalities: nationalities,
			additionalDemographics: additionalDemographics, trackPayGap: trackPayGap, payGap: payGap, promoMale: promoMale, promoFemale: promoFemale, promoOther: promoOther, turnoverMale: turnoverMale,
			turnoverFemale: turnoverFemale,turnoverOther: turnoverOther, underrepresentedLeadership: underrepresentedLeadership, diPolicy: diPolicy, policyRef: policyRef, responsibleRole: responsibleRole,
			hasTargets: hasTargets, targetsDescription: targetsDescription, initiatives: initiatives, initiativesOther: initiativesOther, hasTraining: hasTraining, trainingFrequency: trainingFrequency, trainingDescription: trainingDescription,
			diversityChange: diversityChange, improvements: improvements, trackMetrics: trackMetrics, metricsTracked: metricsTracked, isDraft
		})
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},

	async getVsmeDiversity() {
		let value = await api.get(`/vsmeDiversityInclusion`)
		if (value?.data?.error?.length > 0) {
			if (value.data.error[0].code === "NOT_FOUND") return null
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			throw error
		}
		return value.data.data?.[0] ?? null
	},

	async updateVsmeDiversity(
		totalEmployees, genderMale, genderFemale, genderOther,
		leaderMale, leaderFemale, leaderOther,
		staffMale, staffFemale, staffOther,
		under25, age25_34, age35_44, age45_54, age55plus,
		nationalities, additionalDemographics,
		trackPayGap, payGap,
		promoMale, promoFemale, promoOther,
		turnoverMale, turnoverFemale, turnoverOther,
		underrepresentedLeadership,
		diPolicy, policyRef, responsibleRole,
		hasTargets, targetsDescription,
		initiatives, initiativesOther,
		hasTraining, trainingFrequency, trainingDescription,
		diversityChange, improvements,
		trackMetrics, metricsTracked, isDraft
	) {
		let value = await api.put(`/vsmeDiversityInclusion`, {
			totalEmployees, genderMale, genderFemale, genderOther,
			leaderMale, leaderFemale, leaderOther,
			staffMale, staffFemale, staffOther,
			under25, age25_34, age35_44, age45_54, age55plus,
			nationalities, additionalDemographics,
			trackPayGap, payGap,
			promoMale, promoFemale, promoOther,
			turnoverMale, turnoverFemale, turnoverOther,
			underrepresentedLeadership,
			diPolicy, policyRef, responsibleRole,
			hasTargets, targetsDescription,
			initiatives, initiativesOther,
			hasTraining, trainingFrequency, trainingDescription,
			diversityChange, improvements,
			trackMetrics, metricsTracked, isDraft
		})
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			throw error
		}
		return value.data.data
	},
}
